export interface ITabChangeController {

    canChangeTab(): Promise<boolean>;
}
